import React, { useCallback } from "react";
import { GlobalBox } from "components/Box/GlobalBox";
import { useDispatch, useSelector } from "react-redux";
import AssessmentIcon from "@mui/icons-material/Assessment";
import { TableInputs } from "components/CardTable/TableInputs";
import { dateValidator } from "helpers/dateValidator";
import { newDate } from "helpers/dateTools";
import { LoadingComponent } from "components/Loading/LoadingComponent";
import { setReportAdvancePaymentsFilters, getReportAdvancePaymentsAction } from "redux/actions/Reports/reportAdvancePayments/reportAdvancePaymentsActions";
import { useSearch } from "hooks/useSearch";

export const ReportAdvancePaymentsView = () => {
  const dispatch = useDispatch();
  const { setSnackbar } = useSearch();
  const { isLoadingComp } = useSelector(({ search }) => search);
  const { startDate, endDate, station } = useSelector(state => state.reportAdvancePayments);

  const handleSubmit = useCallback((e, isPdf = true) => {
    e.preventDefault();
    if (!station?.id) { setSnackbar("Falta seleccionar planta.", 'warning'); return; }
    if (dateValidator(startDate, endDate, 31, setSnackbar)) return;
    dispatch(getReportAdvancePaymentsAction({ startDate, endDate, station, isPdf }));
  }, [startDate, endDate, station]);

  return (
    <GlobalBox title="Reporte Anticipos" icon={<AssessmentIcon />}>
      {isLoadingComp?.loadingReportAdvancePayments
        ? <LoadingComponent />
        : <TableInputs
            reducer="reportAdvancePayments"
            dates
            stations
            maxDate={newDate()}
            dispatchAction={setReportAdvancePaymentsFilters}
            submitAction={handleSubmit}
            submitSecond={(e) => handleSubmit(e, false)}
            submitButtonName="PDF"
          />
      }
    </GlobalBox>
  );
};
